namespace Matrix.Rebalancer {
    export interface SummaryViewAccountRow {
        InstanceCode?: string;
        AccountCode?: string;
        SortOrder?: number;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        InstanceViewCode?: string;
        InstanceName?: string;
        InstanceRowId?: number;
        AccountName?: string;
        AccountRowId?: number;
    }

    export namespace SummaryViewAccountRow {
        export const idProperty = 'RowId';
        export const nameProperty = 'InstanceCode';
        export const localTextPrefix = 'Rebalancer.SummaryViewAccount';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            InstanceCode = "InstanceCode",
            AccountCode = "AccountCode",
            SortOrder = "SortOrder",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            InstanceViewCode = "InstanceViewCode",
            InstanceName = "InstanceName",
            InstanceRowId = "InstanceRowId",
            AccountName = "AccountName",
            AccountRowId = "AccountRowId"
        }
    }
}
